import React from 'react'
import { Redirect, Router } from '@gatsbyjs/reach-router'
import { Text } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import Header from './screens/header/header'

const Transformer = React.lazy(() => import('./screens/mapping'))
const Converter = React.lazy(() => import('./screens/converter'))

function App() {
  return (
    <div>
      <Header />
      <React.Suspense
        fallback={
          <Text>
            <Message id="app.suspense.fallbackText" />
          </Text>
        }
      >
        <Router>
          <Transformer path="/mapping/" />
          <Converter path="/converter/" />
          <Redirect
            from="*" 
            to="/tools/limited/api-transformer/mapping/"
            noThrow
          />
        </Router>
      </React.Suspense>
    </div>
  )
}

export default App
